import axios from "axios";

let client = axios.create({});

export const externalHttpClient = client;
